// src/pages/BillingSuccess.jsx

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./BillingSuccess.css";

const REDIRECT_SECONDS = 10;

export default function BillingSuccess() {
  const navigate = useNavigate();

  const [secondsRemaining, setSecondsRemaining] =
    useState(REDIRECT_SECONDS);

  const goToDashboard = () => {
    navigate("/", {
      replace: true,
    });
  };

  useEffect(() => {
    const countdown = window.setInterval(() => {
      setSecondsRemaining((currentSeconds) => {
        if (currentSeconds <= 1) {
          window.clearInterval(countdown);

          navigate("/", {
            replace: true,
          });

          return 0;
        }

        return currentSeconds - 1;
      });
    }, 1000);

    return () => {
      window.clearInterval(countdown);
    };
  }, [navigate]);

  const progress =
    ((REDIRECT_SECONDS - secondsRemaining) /
      REDIRECT_SECONDS) *
    100;

  return (
    <main className="billing-success-page">
      <section
        className="billing-success-card"
        aria-labelledby="billing-success-title"
      >
        <div
          className="billing-success-icon"
          aria-hidden="true"
        >
          <i className="bi bi-check-lg" />
        </div>

        <div className="billing-success-content">
          <span className="billing-success-label">
            Payment confirmed
          </span>

          <h1 id="billing-success-title">
            Subscription successful
          </h1>

          <p>
            Your payment has been received. Your vehicle
            subscription is now being updated.
          </p>
        </div>

        <div className="billing-success-summary">
          <div className="billing-success-summary-icon">
            <i
              className="bi bi-truck"
              aria-hidden="true"
            />
          </div>

          <div>
            <span>Vehicle subscription</span>

            <strong>Ready to use</strong>
          </div>
        </div>

        <div className="billing-success-redirect">
          <div className="billing-success-redirect-row">
            <span>Returning to dashboard</span>

            <strong>
              {secondsRemaining}s
            </strong>
          </div>

          <div
            className="billing-success-progress"
            aria-hidden="true"
          >
            <span
              style={{
                width: `${progress}%`,
              }}
            />
          </div>
        </div>

        <button
          type="button"
          className="billing-success-button"
          onClick={goToDashboard}
        >
          <span>Go to Dashboard</span>

          <i
            className="bi bi-arrow-right"
            aria-hidden="true"
          />
        </button>
      </section>
    </main>
  );
}